import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import * as yup from 'yup';
import { CloseIcon, NamelessLogo } from "../../images";
import { CheckCircle, LoaderPinwheel } from 'lucide-react';

const schema = yup.object({
    fullname: yup.string().required('Full Name is required'),
    email: yup.string().email('Email is invalid').required('Email is required'),
    phone: yup.string().required('Phone Number is required').length(11, 'Phone Number must be 11 digit'),
    help: yup.string().required('What service are you interested in?')
})
const initialState = {
    fullname: '',
    email: '',
    phone: '',
    help: ''
}
const Appointment = ({ show, handleClose }) => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema),
        defaultValues: initialState
    });
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (data) => {
        const tableRows = Object.keys(initialState).map((key) => {
            return `
                <tr>
                <th style="border: 1px solid #ddd; padding: 10px; background-color: #f0f5f0;">${key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1').trim()}</th>
                <td style="border: 1px solid #ddd; padding: 10px;">${data[key]}</td>
                </tr>
            `;
        }).join('');

        try {
            setSubmitting(true)
            // Remove the data URI prefix
            const fd = new FormData()
            Object.entries({
                sender: JSON.stringify({ name: 'Myrtle Lab', email: 'info@myrtlelab.com.ng' }),
                replyTo: JSON.stringify({ name: data.name, email: data.email }),
                to: JSON.stringify([{ email: process.env.REACT_APP_TO_ADDRESS }]),
                subject: "New Schedule Appointment form Submitted",
                htmlContent: `
						<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
							<h2 style="color: #333;">Schedule Appointment</h2>
              <p style="font-size: 16px; line-height: 24px;">A new Schedule Appointment has been submitted on the website with the following details:</p>
              <table style="border-collapse: collapse; border: 1px solid #ddd;">
                  ${tableRows}
              </table>
              <p style="font-size: 16px; line-height: 24px;"> you can reply to this message</p>
              <p style="font-size: 16px; line-height: 24px;">Best regards,</p>
              <p style="font-size: 16px; line-height: 24px;">Website Admin</p>
						</div>
					`
            }).forEach(([key, value]) => {
                fd.append(key, value)
            })
            const res = await fetch(process.env.REACT_APP_EMAIL_URL, {
                method: 'POST',
                headers: {
                },
                body: fd
            });

            if (res.status === 200) {
                reset();
                toast(`Schedule Appointment form Submitted Successfully!`, {
                    icon: <CheckCircle />,
                    className: 'bg-green-500 text-white'
                })
                handleClose()
                // toast.success("RSVP Submitted Successfully!", {
                //   description: "Thank you for your response. We can't wait to celebrate with you!",
                // });
            }

        } catch (error) {
            console.error(error);
        } finally {
            setSubmitting(false)
        }
    };

    if (!show) {
        return null;
    }
    const onCloseClick = () => {
      reset()
      handleClose()
    }
    

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-50">
            <div className="sm:w-[520px] w-full bg-white pb-[37px] rounded-md shadow-lg sm:pt-[35px] pt-[25px]">
                <div className="justify-between px-5 my-4 sm:flex sm:py-2">
                    <img src={NamelessLogo} alt="logo" />
                    <button onClick={onCloseClick} className="max-[640px]:absolute max-[640px]:top-[10px] max-[640px]:right-[10px]">
                        <img src={CloseIcon} alt="close icon" />
                    </button>
                </div>

                <h4 className="text-[22px] leading-[28px] font-semibold text-[#26262A] text-center">Schedule Appointment</h4>

                <form className="flex flex-col gap-3 w-full px-[32px] mt-[32px]" onSubmit={handleSubmit(onSubmit)}>
                    <div>
                        <label htmlFor="fullname" className="text-[16px] leading-[24px] font-semibold text-[#26262A] mb-2 block">
                            Full Name <span className="text-[#D34222]">*</span>
                        </label>
                        <input
                            type="text"
                            {...register("fullname")}
                            id="fullname"
                            placeholder="Type in your full name"
                            className="h-[48px] w-full border-[1px] border-[#C7CAD8] px-[12px] placeholder-[#C7CAD8] focus:outline-none"
                            aria-label="Full Name"
                        />
                        {errors.fullname && <span className="text-xs text-[#D34222]">{errors.fullname.message}</span>}
                    </div>

                    <div>
                        <label htmlFor="email" className="text-[16px] leading-[24px] font-semibold text-[#26262A] mb-2 block">
                            Email <span className="text-[#D34222]">*</span>
                        </label>
                        <input
                            type="email"
                            {...register("email")}
                            id="email"
                            placeholder="Type in your email"
                            className="h-[48px] w-full border-[1px] border-[#C7CAD8] px-[12px] placeholder-[#C7CAD8] focus:outline-none"
                            aria-label="Email"
                        />
                        {errors.email && <span className="text-xs text-[#D34222]">{errors.email.message}</span>}
                    </div>

                    <div>
                        <label htmlFor="phone" className="text-[16px] leading-[24px] font-semibold text-[#26262A] mb-2 block">
                            Phone <span className="text-[#D34222]">*</span>
                        </label>
                        <input
                            type="tel"
                            {...register("phone")}
                            id="phone"
                            placeholder="Type in your phone number"
                            className="h-[48px] w-full border-[1px] border-[#C7CAD8] px-[12px] placeholder-[#C7CAD8] focus:outline-none"
                            aria-label="Phone"
                        />
                        {errors.phone && <span className="text-xs text-[#D34222]">{errors.phone.message}</span>}
                    </div>

                    <div>
                        <label htmlFor="help" className="text-[16px] leading-[24px] font-semibold text-[#26262A] mb-2 block">
                            What service are you interested in? <span className="text-[#D34222]">*</span>
                        </label>
                        <textarea
                            name="help"
                            id="help"
                            {...register("help")}
                            placeholder="How can we help you?"
                            className="border-[1px] border-[#C7CAD8] w-full h-[145px] p-[12px] placeholder-[#C7CAD8] focus:outline-none"
                            aria-label="Service Interest"
                        ></textarea>
                        {errors.help && <span className="text-xs text-[#D34222]">{errors.help.message}</span>}
                    </div>

                    <div className="flex justify-center">
                        <button type="submit" className={`h-[48px] ${!submitting ? 'w-[148px]': 'rounded-full px-1'} transition-all duration-500 bg-[#275A53] text-[#FFFFFF]`}>
                            {submitting && <LoaderPinwheel className="animate-spin" size={38} />}
                            {!submitting && <span>Submit</span>}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Appointment;
